export type TUxfbAttributes = Readonly<Record<string, string>>;

export const sendUXSEvent = (name: string, attributes?: TUxfbAttributes) => {
  if (typeof window !== 'undefined' && window.UXS) {
    if (attributes === undefined) {
      window.UXS.sendEvent(name);

      return;
    }

    window.UXS.sendEvent(name, attributes);
  }
};
